// @flow
import * as React from 'react';
import { Box, Button } from '@locus-taxy/neo-ui';

type Props = {
    disabled?: boolean,
    onUpload: (file: File) => void,
    icon?: string,
    text: string
};

const UploadButton = ({
    disabled,
    onUpload,
    icon = 'add',
    text
}: Props): React.Node => {
    const uploadInputRef = React.useRef(null);

    const handleFileChange = e => {
        const { files } = e.target;
        onUpload(files[0]);
    };

    return (
        <Box>
            <input
                ref={uploadInputRef}
                style={{ display: 'none' }}
                type="file"
                accept=".csv"
                multiple={false}
                onChange={handleFileChange}
                // Hack: This forces the onChange to trigger everytime even if the same file is uploaded.
                value=""
            />

            <Button
                appearance="ghost"
                palette="primary"
                size="small"
                icon={icon}
                onClick={() => {
                    uploadInputRef.current?.click();
                }}
                disabled={disabled}
            >
                {text}
            </Button>
        </Box>
    );
};

export default UploadButton;
